import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper } from '@mui/material';
import FormPeriodo from '../../components/Periodos/FormPeriodo';
import { criarPeriodo, obterPeriodo, atualizarPeriodo } from '../../services/periodoService';

const CriarEditarPeriodoPage = () => {
  const [periodo, setPeriodo] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      const fetchPeriodo = async () => {
        try {
          const data = await obterPeriodo(id);
          setPeriodo(data);
        } catch (error) {
          console.error('Erro ao buscar período:', error);
          // TODO: Adicionar tratamento de erro e feedback ao usuário
        }
      };

      fetchPeriodo();
    }
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    try {
      if (isEditMode) {
        await atualizarPeriodo(id, formData);
      } else {
        await criarPeriodo(formData);
      }
      navigate('/periodos');
    } catch (error) {
      console.error('Erro ao salvar período:', error);
      // TODO: Adicionar tratamento de erro e feedback ao usuário
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Período' : 'Criar Novo Período'}
      </Typography>
      <FormPeriodo 
        onSubmit={handleSubmit} 
        periodoInicial={periodo}
      />
    </Paper>
  );
};

export default CriarEditarPeriodoPage;